import { Component } from '@theme/component';

export class AnnouncementBar extends Component {
  #resizeObserver = null;

  connectedCallback() {
    super.connectedCallback();

    var self = this;
    requestAnimationFrame(function () {
      self.#setupMarquee();
    });
  }

  #setupMarquee() {
    var slidesContainer = this.querySelector('.announcement-bar__slides');
    if (!slidesContainer) return;

    var slides = slidesContainer.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 1) return;

    var track = document.createElement('div');
    track.classList.add('marquee-track');
    track.setAttribute('aria-hidden', 'true');

    var fragment = document.createDocumentFragment();
    var i, set;
    for (set = 0; set < 2; set++) {
      for (i = 0; i < slides.length; i++) {
        fragment.appendChild(slides[i].cloneNode(true));
      }
    }
    track.appendChild(fragment);

    slidesContainer.innerHTML = '';
    slidesContainer.appendChild(track);

    var containerWidth = this.offsetWidth;
    var trackWidth = track.scrollWidth;
    var originalSetWidth = trackWidth / 2;

    if (containerWidth > 0 && trackWidth < containerWidth * 2) {
      var setsNeeded = Math.ceil((containerWidth * 2) / originalSetWidth);
      if (setsNeeded % 2 !== 0) setsNeeded++;
      if (setsNeeded > 2) {
        track.innerHTML = '';
        fragment = document.createDocumentFragment();
        for (set = 0; set < setsNeeded; set++) {
          for (i = 0; i < slides.length; i++) {
            fragment.appendChild(slides[i].cloneNode(true));
          }
        }
        track.appendChild(fragment);
        originalSetWidth = track.scrollWidth / setsNeeded;
      }
    }

    this.style.setProperty('--scroll-distance', '-50%');

    var speed = parseFloat(this.getAttribute('speed')) || 30;
    this.style.setProperty('--scroll-duration', speed + 's');

    var direction = this.getAttribute('direction') || 'left';
    this.style.setProperty(
      '--scroll-direction',
      direction === 'right' ? 'reverse' : 'normal'
    );

    var self = this;

    this.addEventListener('mouseenter', function () {
      track.style.animationPlayState = 'paused';
    });
    this.addEventListener('mouseleave', function () {
      track.style.animationPlayState = 'running';
    });

    document.addEventListener('visibilitychange', function () {
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    });

    this.#resizeObserver = new ResizeObserver(function () {
      self.style.setProperty('--marquee-width', (track.scrollWidth / 2) + 'px');
    });
    this.#resizeObserver.observe(track);
  }

  disconnectedCallback() {
    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
    }
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
